import React from "react";
import { CloseOutlined } from "@ant-design/icons";

const LabelSelector = ({ labels = [], selectedLabels, onToggleLabel }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px",
        padding: "8px",
      }}
    >
      {labels.map((label) => {
        const isSelected = selectedLabels.includes(label);
        let bgColor, textColor;
        if (label === "Positive") {
          bgColor = isSelected ? "#78D0EF" : "#F3F4F6";
          textColor = isSelected ? "#065f46" : "#374151";
        } else if (label === "Neutral") {
          bgColor = isSelected ? "#BDBCC8" : "#F3F4F6";
          textColor = isSelected ? "#6b7280" : "#374151";
        } else if (label === "Negative") {
          bgColor = isSelected ? "#F59694" : "#F3F4F6";
          textColor = isSelected ? "#991b1b" : "#374151";
        } else {
          bgColor = "#F3F4F6";
          textColor = "#374151";
        }

        return (
          <div
            key={label}
            onClick={() => onToggleLabel(label)}onMouseDown={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 12px",
              borderRadius: "9999px",
              background: bgColor,
              border: isSelected ? "none" : "1px solid #E5E7EB",
              color: textColor,
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              boxShadow: isSelected ? "0px 2px 4px rgba(0, 0, 0, 0.1)" : "none",
              minWidth: "80px",
              textAlign: "center",
            }}
          >
            <span
              style={{
                marginRight: isSelected ? "6px" : "0px",
                fontWeight: isSelected ? 600 : 400,
                fontSize: "14px",
              }}
            >
              {label}
            </span>
            {isSelected && <CloseOutlined style={{ fontSize: "12px", opacity: 0.9 }} />}
          </div>
        );
      })}
    </div>
  );
};

export default LabelSelector;
